import React from "react"

import { joinClasses, changeView, useClasses } from "../globals";
import { getContext } from "../simgate";

import {
  Box,
  Button,
  Divider,
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"

// Icons
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import { runInAction } from "mobx";


export const SignUpComplete = ({ firstName, lastName, app }) => {
  const classes = useClasses();

  return (
    <React.Fragment>
      <Box className={classes._Padding}>
        <Box className={classes._Margin}>
          <Alert severity="success">
            Welcome {firstName} {lastName}!
            <br />
            Thank you for signing up.
          </Alert>
        </Box>
      </Box>

      <Divider />
      <Box className={classes._Padding}>
        <Box className={classes._Margin}>
          <Button
            variant="text"
            fullWidth
            onClick={async () => {
              const [context] = await getContext();
              runInAction(() => {
                app.context = context.context;
              });
            }}
            endIcon={<ChevronRightIcon />}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  )
}

SignUpComplete.title = "Sign Up Successful"